/**
 * EscalationCard — Renders one escalation within a workflow (collapsible).
 *
 * Shows the escalation name, period range, overlap warning, and
 * an expand/collapse toggle to reveal output details.
 *
 * Props:
 *   escalation      — escalation data object
 *   isExpanded      — whether output details are visible
 *   onToggle        — callback to toggle expanded state
 *   onEdit          — callback to open edit drawer
 *   hasOverlap      — boolean, shows warning if period overlaps
 *   campusSettings  — campus settings for output visibility
 */

import OutputList from './OutputList.jsx';

const EscalationCard = ({
    escalation,
    isExpanded,
    onToggle,
    onEdit,
    hasOverlap,
    campusSettings,
}) => {
    const periodStartMin = Math.floor(escalation.period_start / 60);
    const periodEndMin = Math.floor(escalation.period_end / 60);

    return (
        <div className={`cf-escalation${hasOverlap ? ' cf-escalation--warning' : ''}`}>
            {hasOverlap ? (
                <div className="cf-card__alert cf-card__alert--warning" style={{ marginBottom: '0.5rem' }}>
                    <svg className="cf-card__alert-icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                    </svg>
                    Escalation period overlaps with another escalation
                </div>
            ) : null}

            <div className="cf-escalation__header">
                <div className="cf-escalation__info">
                    <h4 className="cf-escalation__name">{escalation.escalation_name}</h4>
                    <p className="cf-escalation__period">
                        Period: {periodStartMin} min – {periodEndMin} min
                    </p>
                </div>
                <div className="cf-escalation__actions">
                    <button
                        className="dp-btn dp-btn--ghost dp-btn--sm"
                        onClick={onEdit}
                    >
                        <svg className="dp-icon-sm" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125" />
                        </svg>
                    </button>
                    <button
                        className="dp-btn dp-btn--secondary dp-btn--sm"
                        onClick={onToggle}
                        style={{ minWidth: '90px' }}
                    >
                        {isExpanded ? 'Hide Details' : 'Show Details'}
                    </button>
                </div>
            </div>

            {isExpanded ? (
                <OutputList outputs={escalation.outputs || []} campusSettings={campusSettings} />
            ) : null}
        </div>
    );
};

export default EscalationCard;
